import { Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import RightChevron from "../../../icons/forward-chevron.svg";
import React from "react";
import "./show_nav.scss";
import { classNames } from "react-extras";
import InfoTooltip from "../info";
export const ShowPageNav = ({
  to,
  title,
  subtitle,
  fullWidth,
  noMinHeight,
  component,
  onClick,
  disabled,
  disabledTooltipMessage,
  tooltip,
  className,
  notification,
  ...props
}) => {
  const history = useHistory();
  return (
    <Col xs={12} md={fullWidth ? 12 : 6} {...props}>
      <DisabledOverlay disabled={disabled} disabledTooltipMessage={disabledTooltipMessage}>
        <div
          className={classNames(
            "show-nav",
            noMinHeight && "no-min-height",
            disabled ? "disabled" : "pointer"
          )}
          onClick={() => {
            if (disabled) return;
            if (onClick) {
              onClick();
              return;
            }
            if (to) history.push(to);
          }}>
          <h3 className={"flex-row-container align-center"}>
            {title} {notification && <div className={"notification"} />}
            {tooltip && <InfoTooltip helpText={tooltip} />}
          </h3>
          <p className="description">{subtitle}</p>
          <img src={RightChevron} alt="right-chevron" />
        </div>
      </DisabledOverlay>
    </Col>
  );
};

const DisabledOverlay = ({ disabled, disabledTooltipMessage, children }) => {
  if (disabled && disabledTooltipMessage) {
    return (
      <OverlayTrigger
        placement={"top"}
        overlay={
          <Tooltip className={"disabled-tooltip"}>
            <div className={"p-hxxxs p-vxxxs"}>{disabledTooltipMessage}</div>
          </Tooltip>
        }>
        {children}
      </OverlayTrigger>
    );
  }
  return children;
};
